<template>
<div class="room-container">
  <Carousel :data="$store.state.adList['roomCarouselNormal']">
    <div class="open-live-wrap">
      <div class="open-live">
        <p class="title">今日已开启</p>
        <p class="count">{{ livingNumber }}</p>
        <button type="button" v-if="userIdentity !== 1" @click="btnHandle(userIdentity)"><span>{{ btnStatus }}</span></button>
      </div>
    </div>
  </Carousel>
  <section class="line-1 main-1 clearfix">
    <div class="hot-living left">
      <h2>聚焦</h2>
      <ul class="yf-article-list">
        <li class="yf-article-list__item ellipsis" v-for="(item, index) in $store.state.adList['roomTopLeftNormal']" :key="index"><i></i><nuxt-link :to="item.link" target="_blank" rel="noopener">{{ item.title }}</nuxt-link></li>
      </ul>
    </div>
    <div class="section2 left">
      <section class="today-star">
        <h2>今日之星</h2>
        <ul>
          <li v-for="item in $store.state.adList['starRoom']" :key="item.id">
            <div class="content clearfix">
              <div class="left avatar">
                <nuxt-link :to="`/room/${item.relationData.id}`" target="_blank" rel="noopener"><img v-lazy="isSupportWebp(item.relationData.userAvatar)" :alt="item.relationData.userName"></nuxt-link>
              </div>
              <div class="left other">
                <div class="authur clearfix">
                  <h3 class="left"><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank" rel="noopener">{{ item.relationData.userName }}</nuxt-link></h3>
                  <button type="button" class="left" :class="{ 'yf-status-open': item.relationData.status === 11, 'yf-status-pause': item.relationData.status === 12, 'yf-status-close': item.relationData.status === 21 || !item.relationData.status }"><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank" rel="noopener">{{ item.relationData.status | famousRoomStatus }}</nuxt-link></button>
                </div>
                <p class="intro ellipsis">{{ item.relationData.introduce }}</p>
                <p class="yf-keyword">
                  <span v-for="(w, index) in item.relationData.label.split(',')" :key="index">{{ w }}</span>
                </p>
              </div>
            </div>
            <h4 class="ellipsis">今日主题：<nuxt-link :to="`/room/${item.relationData.id}`" target="_blank" rel="noopener">{{ item.relationData.topicName }}</nuxt-link></h4>
            <!-- <div class="position">
              <nuxt-link :to="`/article/list/${item.relationData.teacherId}`" title="藏金阁" target="_blank"><i class="iconfont icon-cjg"></i></nuxt-link>
              <nuxt-link :to="`/vip/detail/${item.relationData.teacherId}`" title="特训班" target="_blank"><i class="iconfont icon-txb"></i></nuxt-link>
              <nuxt-link :to="`/question/list/${item.relationData.teacherId}`" title="问答" target="_blank"><i class="iconfont icon-wenda"></i></nuxt-link>
            </div> -->
          </li>
        </ul>
      </section>
      <section class="new-star">
        <h2>近期入驻</h2>
        <ul class="clearfix">
          <li class="left clearfix" v-for="item in $store.state.adList['newRoom']" :key="item.id">
            <nuxt-link :to="`/room/${item.relationData.id}`" target="_blank" rel="noopener"><img v-lazy="isSupportWebp(item.relationData.userAvatar)" :alt="item.relationData.userName" class="left"></nuxt-link>
            <div class="content left">
              <h4 class="ellipsis"><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank" rel="noopener">{{ item.relationData.userName }}</nuxt-link></h4>
              <p class="intro ellipsis">{{ item.relationData.introduce }}</p>
            </div>
          </li>
        </ul>
      </section>
    </div>
    <div class="rank-list left">
      <div class="title clearfix">
        <h2 class="left">月均排行</h2>
        <p class="right">
          <button type="button" v-for="(item, index) in btns" @click="getRankData(index + 1)" :class="{ active: rankMark === index }" :key="item">{{ item }}</button>
        </p>
      </div>
      <ol class="yf-rank-list" v-if="rankData">
        <li class="clearfix yf-rank-list__item" v-for="item in rankData" :key="item.roomId">
          <i class="left rank" :class="`rank-${item.rank}`">{{ item.rank }}</i>
          <h4 class="left ellipsis"><nuxt-link :to="`/room/${item.roomId}`" target="_blank">{{ item.teacherName }}</nuxt-link></h4>
          <span class="left ticket ellipsis">{{ item.num }}</span>
          <svg class="arrow-up" width="20" height="20" v-if="item.rank <= item.preRank">
            <circle cx="10" cy="10" r="9" stroke="#ff7a7a" stroke-width="1" fill="#fff" />
            <path d="M 5 10 l 5 -5" stroke="#ff7a7a" stroke-width="1" fill="none" />
            <path d="M 10 5 l 5 5" stroke="#ff7a7a" stroke-width="1" fill="none" />
            <path d="M 10 5 l 0 10" stroke="#ff7a7a" stroke-width="1" fill="none" />
          </svg>
          <svg class="arrow-down" width="20" height="20" v-else>
            <circle cx="10" cy="10" r="9" stroke="#63c9ad" stroke-width="1" fill="#fff" />
            <path d="M 5 10 l 5 5" stroke="#63c9ad" stroke-width="1" fill="none" />
            <path d="M 10 15 l 5 -5" stroke="#63c9ad" stroke-width="1" fill="none" />
            <path d="M 10 5 l 0 10" stroke="#63c9ad" stroke-width="1" fill="none" />
          </svg>
        </li>
      </ol>
    </div>
  </section>
  <section class="line-2 main-1" v-if="$store.state.adList['famousRoom']">
    <h2>名师</h2>
    <ul class="yf-home-live-list clearfix">
      <li class="yf-home-live-list__item left" :class="teacherBedge(item.relationData.tags)" v-for="item in $store.state.adList['famousRoom'].slice(0, 8)" :key="item.id">
        <div class="clearfix">
          <div class="face left">
            <nuxt-link :to="`/room/${item.relationData.id}`" target="_blank"><img v-lazy="isSupportWebp(item.relationData.userAvatar)" :alt="item.relationData.userName"></nuxt-link>
          </div>
          <div class="content left">
            <div class="name clearfix">
              <h3 class="left ellipsis"><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank">{{ item.relationData.userName }}</nuxt-link></h3>
              <button type="button" class="right" :class="{ 'yf-status-open': item.relationData.status === 11, 'yf-status-pause': item.relationData.status === 12, 'yf-status-close': item.relationData.status === 21 }"><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank">{{ item.relationData.status | famousRoomStatus }}</nuxt-link></button>
            </div>
            <p class="intro ellipsis">{{ item.relationData.introduce }}</p>
            <p class="yf-keyword">
              <span v-for="(w, index) in item.relationData.label.split(',')" :key="index">{{ w }}</span>
            </p>
          </div>
        </div>
        <p class="title ellipsis"><span>主题：</span><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank">{{ item.relationData.topicName }}</nuxt-link></p>
      </li>
    </ul>
  </section>
  <section class="line-3 main-1">
    <h2>热门</h2>
    <ul class="yf-home-live-list clearfix">
      <li class="yf-home-live-list__item left" :class="teacherBedge(item.relationData.tags)" v-for="item of $store.state.adList['hotRoom']" :key="item.id">
        <div class="clearfix">
          <div class="face left">
            <nuxt-link :to="`/room/${item.relationData.id}`" target="_blank"><img v-lazy="isSupportWebp(item.relationData.userAvatar)" :alt="item.relationData.userName"></nuxt-link>
          </div>
          <div class="content left">
            <div class="name clearfix">
              <h3 class="left ellipsis"><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank">{{ item.relationData.userName }}</nuxt-link></h3>
              <button type="button" class="right" :class="{ 'yf-status-open': item.relationData.status === 11, 'yf-status-pause': item.relationData.status === 12, 'yf-status-close': item.relationData.status === 21 || item.relationData.status === undefined }"><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank">{{ item.relationData.status | famousRoomStatus }}</nuxt-link></button>
            </div>
            <p class="intro ellipsis">{{ item.relationData.introduce }}</p>
            <p class="yf-keyword" v-if="item.relationData.label">
              <span v-for="w in item.relationData.label.split(',')" :key="w">{{ w }}</span>
            </p>
          </div>
        </div>
        <p class="title ellipsis"><span>主题：</span><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank">{{ item.relationData.topicName }}</nuxt-link></p>
      </li>
    </ul>
  </section>
  <section class="line-4 main-1">
    <img width="1200" height="90" src="~assets/ad-2code.jpg" alt="二维码">
  </section>
  <section class="line-5 main-1">
    <div class="live-nav clearfix">
      <h3 class="left">全部</h3>
      <div class="menu left clearfix">
        <span class="left" v-for="(v, i) in menu" :key="v" @click="getLiveData(999, i)" :class="{ active: menuMark === i }">{{ v }}</span>
      </div>
      <div class="right search clearfix">
        <p class="left"><input v-model.trim="searched" placeholder="请输入关键字..."></p>
        <p class="left" @click.stop="onSearch"><i class="iconfont icon-ss"></i></p>
      </div>
    </div>
    <ul class="yf-home-live-list clearfix">
      <template v-if="liveData.length">
        <li class="yf-home-live-list__item left" :class="teacherBedge(item.tags)" v-for="item in liveData" :key="item.id">
          <div class="clearfix">
            <div class="face left">
              <nuxt-link :to="`/room/${item.id}`" target="_blank"><img v-lazy="isSupportWebp(item.teacherAvatar)" :alt="item.teacherName"></nuxt-link>
            </div>
            <div class="content left">
              <div class="name clearfix">
                <h3 class="left ellipsis"><nuxt-link :to="`/room/${item.id}`" target="_blank">{{ item.teacherName }}</nuxt-link></h3>
                <button type="button" class="right" :class="{ 'yf-status-open': item.lastTopicStatus === 11, 'yf-status-pause': item.lastTopicStatus === 12, 'yf-status-close': item.lastTopicStatus === 21 || item.lastTopicStatus === undefined }"><nuxt-link :to="`/room/${item.id}`" target="_blank">{{ item.lastTopicStatus | famousRoomStatus }}</nuxt-link></button>
              </div>
              <p class="intro ellipsis">{{ item.introduce }}</p>
              <p class="yf-keyword" v-if="item.label">
                <span v-for="w in item.label.split(',')" :key="w">{{ w }}</span>
              </p>
            </div>
          </div>
          <p class="title ellipsis"><span>主题：</span><nuxt-link :to="`/room/${item.id}`" target="_blank">{{ item.lastTopicName }}</nuxt-link></p>
        </li>
      </template>
      <template v-else>
        <li>暂无相关数据</li>
      </template>
    </ul>
  </section>
  <!-- 开启今日直播 -->
</div>
</template>

<script>
import { mapState } from 'vuex'
import Dialog from '~/utils/Dialog'
import { famousRoomStatus, teacherBedge } from '~/utils/Filters'
import Webp from '@/mixins/Webp'
import Carousel from '@/components/Carousel'

export default {
  mixins: [Webp],
  name: 'Room',
  head () {
    return {
      title: '互动_实时行情_投资者交流_趋势解盘_深度分析',
      meta: [
        { hid: 'keywords', name: 'keywords', content: '实时行情_投资者交流_趋势解盘_深度分析' },
      ]
    }
  },
  async asyncData ({ store, $axios }) {
    let { list } = await $axios._get('/Room/List', { num: 999, order: 'username' })
    let livingNumber = list.filter(_ => _.lastTopicStatus && _.lastTopicStatus !== 21).length

    return {
      liveData: list,
      livingNumber
    }
  },
  data () {
    return {
      btns: ['投票', '礼物', '人气'],
      rankMark: 1,
      rankData: [],
      menu: ['按首字母排序', '按人气排序', '按入驻时间排序'],
      menuMark: 0,
      liveData: [],
      userIdentity: 0,
      btnStatus: '申请入驻',
      searched: ''
    }
  },
  mounted () {
    if (this.$isLogin() && this.isTeacher) {
      this.$store.dispatch('teacher/getInfo', this.authUser.id).then(res => {
        this.verifyUserIdentity()
      })
    }
    this.getRankData(1)
    // 直播大厅
    this.getLiveData(999, 0)
    this.$store.dispatch('getAd', ['roomCarouselNormal', 'roomTopLeftNormal', 'starRoom', 'newRoom', 'famousRoom', 'hotRoom'])
  },
  methods: {
    getRankData (type) {
      // 禁止重复请求
      if (this.rankMark + 1 === type) return
      // 月均排行
      this.rankMark = type - 1
      this.$axios._get('Teacher/Rank', { type }).then(res => {
        this.rankData = res
      }).catch(err => {
        console.log(`rank-${type}_err: ` + err)
      })
    },
    getLiveData (num = null, index = null, keyword = null) {
      this.menuMark = index
      let type
      switch (index) {
        case 0:
          type = 'username'
          break
        case 1:
          type = 'hot'
          break
        case 2:
          type = 'date'
          break
      }
      this.$axios._get('/Room/List', { num, order: type, keyword }).then(res => {
        this.liveData = res.list
      })
    },
    verifyUserIdentity () {
      // 确认用户身份让按钮显示相应的文字和有相应的操作

      // 登录了是老师，但是没开通直播室
      if (this.teacher && this.teacher.roomId < 1) {
        this.userIdentity = 1
        return false
      }

      if (this.teacher.roomId > 0) {
        this.$store.dispatch('room/initRoomData', this.teacher.roomId).then(res => {
          if (res.lastTopicStatus === 21 || !res.lastTopicStatus) {
            // 当前不在直播
            this.userIdentity = 2
            this.btnStatus = '开启今日直播'
          } else {
            // 直播中
            this.userIdentity = 3
            this.btnStatus = '进入直播室'
          }
        }).catch(err => {
          console.log(11111, err)
        })
      }
    },
    btnHandle (s) {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      } else if (!this.isTeacher) {
        // 申请成为老师
        this.$router.push('/room/apply')
        return
      }
      switch (s) {
        case 2:
          // 开启今日直播
          this.$router.push('user/live')
          break
        case 3:
          // 直接进入直播室
          this.$router.push(`room/${this.teacher.roomId}`)
          break
      }
    },
    onSearch () {
      // 搜索想要查看的直播老师
      if (this.searched) {
        this.getLiveData(null, null, this.searched)
      }
    },
    teacherBedge
  },
  computed: {
    ...mapState({
      authUser: state => state.user.data,
      teacher: state => state.teacher.data,
      roomData: state => state.room.data
    }),
    isTeacher () {
      return this.$store.getters['user/isTeacher']
    }
  },
  filters: {
    famousRoomStatus
  },
  components: {
    Carousel
  }
}
</script>

<style lang="less">
.room-container {
  // 通用
  h2 {
    font-size: 20px; line-height: 1; margin: 30px 0 20px 0;
  }
  img { display: block; }
  .el-dialog__body { padding-top: 20px; }
  .el-form-item {
    width: 380px; margin-left: 40px;
  }
  .el-checkbox:nth-child(1) { margin-left: 0; }
  .el-checkbox { margin-left: 16px; }
  .el-select { width: 100%; }

  .el-tag { margin-top: 5px; }
  // 常规
  .component__carousel {
    .carousel-item {
      img {
        transform: translateX(-70%);
      }
    }
    .indicators {
      transform: translateX(-165%);
    }
    .open-live-wrap {
      position: absolute; left: 50%; top: 0; z-index: 100; background-color: transparent; width: 1200px; height: 1px;transform: translateX(-50%);
      .open-live {
        position: absolute; right: 0; bottom: -250px; z-index: 100; width: 300px; height: 225px; background-color: #fff; background: -webkit-linear-gradient(top, #fff, #f3f5fa); text-align: center; font-weight: 600;
        .title {
          color: #333; font-size: 20px; margin-top: 40px; cursor: default;
        }
        .count {
          font-size: 56px; line-height: 1; margin-top: 15px; text-shadow: 0 4px 4px rgba(252, 61, 49, .5); color: #fc3d31; cursor: default;
          background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(#fe7013), to(#fc3d31));
          -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
        }
        button {
          display: inline-block; width: 210px; height: 46px; background-color: #ca041e; background-image: url(~assets/room-button.png); margin-top: 15px; border-radius: 23px; box-shadow: 0 4px 8px 2px rgba(202, 4, 30, .5) ;
          span {
            font-size: 16px; font-weight: 600; color: #fff; margin-top: -10px;
          }
        }
      }
    }
  }
  .line-1 {
    .hot-living {
      .yf-article-list {
        width: 370px; height: 448px; overflow: hidden;
        .yf-article-list__item:first-child { margin-top: 0; }
        .yf-article-list__item:not(:first-child) { margin-top: 32px; }
      }
    }
    .section2 {
      margin-left: 20px;
      .today-star {
        ul {
          border: 1px solid #eaeaea; width: 500px;
          li {
            padding: 20px; position: relative;
            &:last-child { border-top: 1px solid #eaeaea; }
            .content {
              img { width: 80px; height: 80px; border-radius: 50%; }
              .other {
                margin-left: 10px;
                .authur {
                  h3 {
                    font-size: 16px; font-weight: 600; line-height: 20px; margin-right: 6px;
                  }
                  button {
                    font-size: 12px; line-height: 20px; border-radius: 10px; padding: 0 8px;
                    a { color: #fff; }
                  }
                }
                p {
                  font-size: 12px; margin-top: 8px;
                  &.intro {
                    color: #999; width: 348px;
                  }
                }
              }
            }
            h4 {
              font-size: 14px; color: #333; line-height: 1; margin-top: 12px; width: 320px;
            }
            .position {
              position: absolute; right: 0; bottom: 20px;
              a {
                display: inline-block; border: 2px solid; width: 40px; height: 40px; border-radius: 50%; text-align: center; margin-right: 15px; transition: all .3s;
                &:nth-child(1) {
                  color: #ffdaa3;
                  &:hover {
                    background-color: #ffdaa3; color: #ffffff; border-color: #ffdaa3;
                  }
                }
                &:nth-child(2) {
                  color: #e2d1f7;
                  &:hover {
                    background-color: #e2d1f7; color: #ffffff; border-color: #e2d1f7;
                  }
                }
                &:nth-child(3) {
                  color: #9cf;
                  &:hover {
                    background-color: #9cf; color: #ffffff; border-color: #9cf;
                  }
                }
                i {
                  font-size: 30px; display: inline-block; padding-top: 5px;
                }
              }
            }
          }
        }
      }
      .new-star {
        h2 {
          margin: 20px 0 18px 0;
        }
        ul {
          border: 1px solid #eaeaea;
          li {
            padding: 14px; width: 249px;
            &:first-child { border-right: 1px solid #eaeaea; }
            img {
              width: 50px; height: 50px; border-radius: 50%;
            }
            .content {
              margin-left: 10px; width: 160px;
              h4 {
                font-size: 16px; font-weight: 600; cursor: pointer;
              }
              .intro {
                color: #666; font-size: 12px; margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .rank-list {
      width: 300px; margin-left: 10px;
      .title {
        p {
          margin-top: 30px;
          button {
            padding: 0 10px; line-height: 20px; border-radius: 10px;
            &.active { background-color: #ffa347; color: #fff; }
            &:not(:last-child) { margin-right: 10px; }
          }
        }
      }
      .yf-rank-list {
        h4 {
          width: 140px;
        }
      }
    }
  }
  .line-2,.line-3 {
    .yf-home-live-list {
      .yf-home-live-list__item {
        width: 300px;
        &:not(:nth-child(4n+1)) { margin-left: -1px; width: 301px; }
        .content {
          margin-left: 10px; width: 178px;
          h3 { width: 120px; }
        }
      }
    }
  }
  .line-4 {
    margin-top: 12px;
  }
  .line-5 {
    margin-bottom: 30px;
    .live-nav {
      margin: 30px 0 20px 0;
      h3 { font-size: 16px; color: #666; line-height: 22px; }
      .menu {
        margin-left: 20px;
        span {
          font-size: 12px; color: #666; line-height: 22px; padding: 0 14px; cursor: pointer;
          &.active { color: #fff; background-color: #e43a3d; }
        }
      }
      .search {
        p {
          input {
            line-height: 26px; height: 30px; text-indent: 6px; outline: 0; margin-right: -1px;
          }
          &:last-child {
            width: 50px; height: 30px; background-color: #c00; text-align: center; cursor: pointer;
            i.iconfont {
              font-size: 20px; display: inline-block; color: #fff; line-height: 30px;
            }
          }
        }
      }
    }
    .yf-home-live-list {
      .yf-home-live-list__item {
        width: 400px; padding: 15px 20px;
        &:not(:nth-child(3n+1)) {
          margin-left: -1px; width: 401px;
        }
        .content {
          margin-left: 20px; width: 258px;
          h3 { width: 120px; }
        }
      }
    }
  }
}
</style>
